<template>
  <div>
    <GoodsTable
      :changeOrderCode="changeOrderCode"
      :disabled="disabled"
      @reloadOrderInfo="() => $emit('reloadOrderInfo')"
    />
  </div>
</template>
<script>
import GoodsTable from './components/goods-table'
export default {
  components: { GoodsTable },
  props: {
    changeOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {}
  },
}
</script>
